
























































import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import { stringUtil } from "@/models/stringUtil.ts";
import { ElementMenuItem, elements } from "@/models/elementMenuItem.ts";
import {
  PresetMenuItem,
  presets,
  PresetType,
  PresetStep,
} from "@/models/presets";
import { Vector2 } from "@babylonjs/core";
import { ElementType, SpecyficType } from "@/models/element";
import { base64Warehouse } from "@/models/base64warehouse";
import store from "@/store";
import ComponentsListItem from "@/components/ComponentsListItem.vue";

@Component({
  components: {
    ComponentsListItem,
  },
})
export default class ComponentsLis extends Vue {
  @Prop({ type: Boolean, required: false }) usePreset!: Boolean;

  private stringUtil = stringUtil;
  private search = "";
  private elements = elements;
  private presets = presets;

  private readonly avatarSize: number =
    this.$store.getters.configuration.tiny === "true" ? 55 : 70;

  private get filteredElements() {
    return this.elements.filter((x) => x.text.includes(this.search));
  }

  private get innerElements() {
    return this.elements.filter(
      (x) =>
        x.specyficType == SpecyficType.SHELF ||
        x.specyficType == SpecyficType.HANGER ||
        x.specyficType == SpecyficType.DRAWER
    );
  }

  private get elementsShelf() {
    return this.elements.filter((x) => x.specyficType == SpecyficType.SHELF);
  }

  private get elementsHanger() {
    return this.elements.filter((x) => x.specyficType == SpecyficType.HANGER);
  }

  private get elementsDrawer() {
    return this.elements.filter((x) => x.specyficType == SpecyficType.DRAWER);
  }

  private get elementsFront() {
    return this.elements.filter(
      (x) => x.type == ElementType.FRONT && !x.subElements.length
    );
  }

  private get elementsDoubleFront() {
    return this.elements.filter(
      (x) => x.type == ElementType.FRONT && x.subElements.length
    );
  }

  private get currentPresets() {
    return this.presets.presetItems.filter(
      (x) =>
        x.step == PresetStep.INNER &&
        x.productName.toLowerCase() ==
          this.$store.getters.configuration.productId
    );
  }

  private getAvatar(url: string) {
    var base = base64Warehouse.getAvatar(url);
    return base ? base : stringUtil.createDownloadUrl(url);
  }

  private getPresetClass(preset: PresetMenuItem): string {
    let result = "clickable";
    if (this.$store.getters.scene.tasks) result += " disabled";
    if (preset.selected) result += " selected";
    return result;
  }

  private selectPreset(preset: PresetMenuItem) {
    presets.presetItems.forEach((x) => (x.selected = false));
    preset.selected = true;
    this.$store.commit("selectPreset", preset);
    this.$store.commit("clearSceneState");
  }
}
